import { graphql } from 'react-relay';

const createWithdrawalRequestsMutation = graphql`
  mutation CreateWithdrawalRequestsMutation(
    $entries: [CashWithdrawalRequestInput]!
    $batchName: String
    $custodian: Custodian!
  ) {
    createWithdrawalRequests(
      entries: $entries,
      batchName: $batchName
      custodian: $custodian
    ) {
      cashTransferRequests {
        id
        amount
        currency
        status
        blocked
        account {
          id
        }
      }
    }
  }
`;

export default createWithdrawalRequestsMutation;
